import React, { useEffect, useRef } from "react"
import types from "prop-types"
import { formShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import { FormIcon } from "shared/icons"
import TaskFormsIcon from "shared/icons/TaskFormsIcon"
import UserAndGroupAssociations from "./UserAndGroupAssociations"

const FormWithWorkflows = ({ form, groupOrUser, workflows }) => {
  const formRef = useRef()

  useEffect(() => {
    formRef.current?.expand()
  }, [])

  return (
    <ItemRow
      ref={formRef}
      collapsable
      itemRowHeaderContent={(
        <div className="flex gap-2 items-center">
          {
            form.icon
              ? <FormIcon className="w-8 h-8" form={form} />
              : <TaskFormsIcon className="w-8 h-8 task-form-icon" />
          }
          <span>{form.title}</span>
        </div>
      )}
      itemRowBody={(
        <>
          {
            workflows.map((workflow) => (
              <ItemRow
                key={`form-workflow-${workflow.id}`}
                className="dark"
                itemRowHeaderContent={(
                  <>
                    <span>{workflow.name}</span>
                    {
                      groupOrUser === "user" && <UserAndGroupAssociations workflow={workflow} />
                    }
                  </>
                )}
              />
            ))
          }
        </>
      )}
    />
  )
}

FormWithWorkflows.propTypes = {
  form: formShape.isRequired,
  groupOrUser: types.oneOf(["group", "user"]).isRequired,
  workflows: types.arrayOf(types.object).isRequired,
}

export default FormWithWorkflows
